export const mockStores =
    [
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Bahçelievler MAĞAZASI",
            "phone": "0312 213 00 56",
            "address": "BAHÇELİEVLER 54 .SOK. NO:1/B ÇANKAYA -ANKARA",
            "id": "ST001",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0,
                1,
                3,
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Öveçler 2 MAĞAZASI",
            "phone": "0312 480 70 32",
            "address": "ÖVEÇLER 4. CADDE NO: 9 / 18 / ÖVEÇLER",
            "id": "ST002",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]

        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Överçler 3 MAĞAZASI",
            "phone": "0312 483 58 14",
            "address": "Öveçler Mah. Kabil Cad No:105/19-20. Çankaya / ANKARA",
            "id": "ST003",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Yıldız MAĞAZASI",
            "phone": "0312 495 02 18",
            "address": "Birlik Mah. Mustafa Bey Apt. 2. Cad. No:9. Çankaya / ANKARA",
            "id": "ST004",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Yıldız 2 MAĞAZASI",
            "phone": "0312 440 51 28",
            "address": "Yıldızevler Mah. Arıtım Sok. No:3. Yıldız,Çankaya / ANKARA",
            "id": "ST005",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Tunalı MAĞAZASI",
            "phone": "0312 425 60 80",
            "address": "Kavaklıdere Mah. Tunalı Hilmi Cad. No:54/17. Çankaya / ANKARA",
            "id": "ST006",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Tunalı 2 MAĞAZASI",
            "phone": "0312 427 87 85",
            "address": "TUNALI HİLMİ CAD. NO:87 85/A 85/B 85/C ÇANKAYA",
            "id": "ST007",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Anıttepe MAĞAZASI",
            "phone": "0312 232 05 30",
            "address": "Maltepe Mah. Gençlik Cad. No:129. Çankaya / ANKARA",
            "id": "ST008",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Balgat MAĞAZASI",
            "phone": "0312 473 25 80",
            "address": "Ehlibeyt Mah. Ceyhun Atıf Kansu Cad. No:126/B-C-D. Balgat, Çankaya / ANKARA",
            "id": "ST009",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Birlik MAĞAZASI",
            "phone": "0312 495 85 84",
            "address": "Birlik Mah. 488. Sok. No:2/10-11. Çankaya / ANKARA",
            "id": "ST010",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Demirtepe MAĞAZASI",
            "phone": "0312 230 60 26",
            "address": "Gazi Mustafa Kemal Bulvarı No:16. Demirtepe, Çankaya / ANKARA",
            "id": "ST011",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Emek MAĞAZASI",
            "phone": "0312 212 97 99",
            "address": "KAZAKİSTAN CAD. 19. SK. NO:113 EMEK",
            "id": "ST012",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "GOP MAĞAZASI",
            "phone": "0312 447 37 35",
            "address": "Büyükesat Mah. Uğur Mumcu Cad. No:48. Gaziosmanpaşa, Çankaya / ANKARA",
            "id": "ST013",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Güvenlik MAĞAZASI",
            "phone": "0312 428 42 48",
            "address": "Ayrancı Mah. Güvenlik Cad. No:8. Aşağıayrancı, Çankaya / ANKARA",
            "id": "ST014",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Hoşdere MAĞAZASI",
            "phone": "0312 442 19 17",
            "address": "Hoşdere Cad. No:178/A. Çankaya / ANKARA",
            "id": "ST015",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Hüseyin Onat MAĞAZASI",
            "phone": "0312 428 30 99",
            "address": "Kuveyt Cad. Hüseyin Onat Sok. No:1. Aşağı Ayrancı, Çankaya / ANKARA",
            "id": "ST016",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "İlker MAĞAZASI",
            "phone": "0312 478 41 40",
            "address": "Dikmen Cad. No:271. Çankaya / ANKARA",
            "id": "ST017",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "İlker 2  MAĞAZASI",
            "phone": "0312 478 06 07",
            "address": "Mürsel Uluç Mah. 1. Cad. No:165. Çankaya / ANKARA",
            "id": "ST018",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Ata MAĞAZASI",
            "phone": "0312 475 68 03",
            "address": "Ata Mah. 4. Cad. No:161. Keklikpınarı, Çankaya / ANKARA",
            "id": "ST019",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Keklik MAĞAZASI",
            "phone": "0312 476 88 81",
            "address": "Dikmen Cad. No:538/13. Dikmen, Çankaya / ANKARA",
            "id": "ST020",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Kentpark  MAĞAZASI",
            "phone": "0312 219 91 72",
            "address": "Mustafa Kemal Mah. Kentpark AVM. Çankaya / ANKARA",
            "id": "ST021",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Kırkkonaklar MAĞAZASI",
            "phone": "0312 495 23 24",
            "address": "Kırkkonaklar Mah. Yazıcıoğlu İş Merkezi, Çankaya / ANKARA.",
            "id": "ST022",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Oran MAĞAZASI",
            "phone": "0312 491 84 31",
            "address": "Turan Güneş Bulvarı 638. Sok. No:1/A. Oran, Çankaya / ANKARA",
            "id": "ST023",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "ODC AVM MAĞAZASI",
            "phone": "0312 284 84 27",
            "address": "Çiğdem Mah. 31. Cad. No:9/19. Yüzüncüyıl, Çankaya / ANKARA",
            "id": "ST024",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Sancak MAĞAZASI",
            "phone": "0312 490 07 38",
            "address": "Sancak Mah. 236. Sok. No:5. Yıldız, Çankaya / ANKARA",
            "id": "ST025",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Saimekadın MAĞAZASI",
            "phone": "0312 369 20 09",
            "address": "Mehtap Mah. Mamak Cad. No:76/A. Mamak / ANKARA",
            "id": "ST026",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Sinan Caddesi MAĞAZASI",
            "phone": "0312 480 84 83",
            "address": "Nazi Çakır Mah. Sinan Cad. No:78/A. Dikmen, Çankaya / ANKARA",
            "id": "ST027",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Sokullu MAĞAZASI",
            "phone": "0312 478 59 19",
            "address": "Harbiye Mah. Sokullu Mehmet Paşa Cad. No: 107.",
            "id": "ST028",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Söğütözü MAĞAZASI",
            "phone": "0312 219 18 41",
            "address": "Söğütözü Mah. Yaşam Cad. No:7/1. Çankaya / ANKARA",
            "id": "ST029",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "100. Yıl MAĞAZASI",
            "phone": "0312 284 16 09",
            "address": "100.YIL ULUPAZARI 37. CADDE 100.YIL İŞÇİ BLOKLARI     / 100.YIL",
            "id": "ST030",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Yukarı Öveçler MAĞAZASI",
            "phone": "0312 502 40 76",
            "address": "Yukarı Öveçler Mahallesi, 1066. Cadde, No:20/A. Dikmen, Çankaya / ANKARA",
            "id": "ST031",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Yıldız 3 MAĞAZASI",
            "phone": "0312 440 58 05",
            "address": "Yıldızevler Mah. 714. Sok. No: 5/B. Çankaya / ANKARA",
            "id": "ST032",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Emek 2 MAĞAZASI",
            "phone": "0312 223 80 54",
            "address": "Emek Mah. Kırım Cad. No:34/A. Çankaya / ANKARA",
            "id": "ST033",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "Yıldızkule MAĞAZASI",
            "phone": "0312 440 69 40",
            "address": "TURAN GÜNEŞ BULVARI YUKARI DİKMEN MAH. ALEXSENDIR DUPCEK CAD. NO:1/A-B-C ÇANKAYA/ANKARA",
            "id": "ST034",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "İran Caddesi MAĞAZASI",
            "phone": "",
            "address": "Çankaya Mah. İran Cad. No:6. Çankaya / ANKARA",
            "id": "ST035",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "İşçi Blokları MAĞAZASI",
            "phone": "0312 220 54 25",
            "address": "İşçi Blokları Mahallesi Muhsin Yazıcıoğlu Caddesi No:45/A Çankaya/Ankara",
            "id": "ST036",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "ÖVEÇLER 3 MAĞAZASI",
            "phone": "0312 483 58 14",
            "address": "ÖVEÇLER 4.CAD. NO:105/19-20 ÇANKAYA",
            "id": "ST037",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "EMEK-3 MAĞAZASI",
            "phone": "0312 213 74 30",
            "address": "EMEK MAHALLESİ BİŞKEK CADDESİ 62/AA ÇANKAYA-ANKARA",
            "id": "ST038",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "çankaya",
            "name": "CEVİZLİDERE-2 MAĞAZASI",
            "phone": "",
            "address": "Huzur Mah. Cevizlidere Cd. No:121 Çankaya/Ankara",
            "id": "ST039",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Çayyolu MAĞAZASI",
            "phone": "0312 236 38 26",
            "address": "MUTLUKÖY MAH. 10. CAD. NO: 176 / 4 / ÜMİTKÖY ANKARA",
            "id": "ST040",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Alacaatlı MAĞAZASI",
            "phone": "0312 238 18 16",
            "address": "ALACAATLI MAH. ALACAATLI CADDESİ NO:12",
            "id": "ST041",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Alacaatlı 2 MAĞAZASI",
            "phone": "0312 238 16 41",
            "address": "Prof. Dr. Ahmet Taner Kışlalı Mah. Alacaatlı Cad. No:48. Çayyolu / ANKARA",
            "id": "ST042",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Mutlukent MAĞAZASI",
            "phone": "0312 235 05 40",
            "address": "Mutlukent Mah. 2015. Cad. No:4/1-2-3",
            "id": "ST043",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Ağaçlı MAĞAZASI",
            "phone": "0312 236 38 35",
            "address": "Eskişehir Yolu 12. Km. No:354. Etimesgut / ANKARA",
            "id": "ST044",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Ümitköy MAĞAZASI",
            "phone": "0312 235 63 30",
            "address": "Ümit Mah. 2432. Cad.No:36/1-2-3. Ümitköy,Çankaya / ANKARA",
            "id": "ST045",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Yaşamkent MAĞAZASI",
            "phone": "0312 240 98 30",
            "address": "Yaşamkent Mah. Alacaatlı Köyü 50. Cad. No:18. Yaşamkent, Çankaya / ANKARA",
            "id": "ST046",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Bağlıca MAĞAZASI",
            "phone": "0312 234 47 74",
            "address": "Bağlıca Mah. Bağlıca Bulvarı No:101. Etimesgut / ANKARA",
            "id": "ST047",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "İncek  MAĞAZASI",
            "phone": "0312 460 19 19",
            "address": "Kızılcaşar Mah. İncek Şehit Savcı Mehmetselim Kiraz Bulvarı No:224. Gölbaşı / ANKARA",
            "id": "ST048",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Yaşamkent 2 MAĞAZASI",
            "phone": "0312 217 32 62",
            "address": "Yaşamkent Mah. 3250. Cad No:21 C Blok. Yaşamkent, Çankaya / ANKARA",
            "id": "ST049",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Beytepe MAĞAZASI",
            "phone": "0312 502 40 14",
            "address": "Beytepe Mah. Kanuni Sultan Süleyman Blv. 5315. Sok. B-1. Çankaya / ANKARA",
            "id": "ST050",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Alacaatlı 3 MAĞAZASI",
            "phone": "",
            "address": "Prof.Dr.Ahmet Taner Kışlalı Mah, Bangabandhu Şeyh Muciburrahman Blv, No:94/M. Çankaya / ANKARA",
            "id": "ST051",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Atabilge MAĞAZASI",
            "phone": "(312) 502 30 11",
            "address": "Alacaatlı Mahallesi 3346 Caddesi No: 60/A Çankaya, Ankara",
            "id": "ST052",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "ümitköy",
            "name": "Vista MAĞAZASI",
            "phone": "(312) 557 12 29",
            "address": "Kızılcaşar Mahallesi, Kızılcaşar Küme Evleri No:406 1-2-3 Gölbaşı",
            "id": "ST053",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "kızılay",
            "name": "kızılay 1  MAĞAZASI",
            "phone": "0312 418 40 61",
            "address": "Milli Müdafaa Cad. No:6/65-66. Kızılay, Çankaya / ANKARA",
            "id": "ST054",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "kızılay",
            "name": "Kolej MAĞAZASI",
            "phone": "0312 434 50 55",
            "address": "Ziya Gökalp Cad. No:27/A. Kızılay, Çankaya / ANKARA",
            "id": "ST055",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "kızılay",
            "name": "Sakarya MAĞAZASI",
            "phone": "0312 434 11 28",
            "address": "Tuna Cad. No:3/20. Kızılay, Çankaya / ANKARA.",
            "id": "ST056",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "kızılay",
            "name": "Ziya Gökalp (Kurtuluş Parkı) MAĞAZASI",
            "phone": "0312 431 71 51",
            "address": "Ziya Gökalp Cad. No:66/A-B. Kızılay, Çankaya / ANKARA",
            "id": "ST057",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "kızılay",
            "name": "Kurtuluş MAĞAZASI",
            "phone": "0312 435 84 10",
            "address": "Cemal Gürsel Cad. No:42. Kurtuluş,Çankaya / ANKARA",
            "id": "ST058",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "kızılay",
            "name": "Esat 2  MAĞAZASI",
            "phone": "0312 437 97 47",
            "address": "Barbaros Mah. Esat Cad. No:84/C-D-E. Çankaya / ANKARA",
            "id": "ST059",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "kızılay",
            "name": "Kocatepe MAĞAZASI",
            "phone": "0312 419 51 12",
            "address": "Kültür Mah. Dr. Mediha Eldem Sok. Kocatepe Camii Sit. No:72/A. Çankaya / ANKARA",
            "id": "ST060",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "kızılay",
            "name": "İzmir Caddesi MAĞAZASI",
            "phone": "0312 419 49 63",
            "address": "İzmir 1. Cadde No: 19 /A. Kızılay, Çankaya / ANKARA",
            "id": "ST061",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "kızılay",
            "name": "Esat MAĞAZASI",
            "phone": "0312 436 52 79",
            "address": "Muhsin Ertuğrul Mah. Ballıbaba Sok. Pazariçi. Çankaya / ANKARA",
            "id": "ST062",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "kızılay",
            "name": "Kızılay-2 MAĞAZASI",
            "phone": "(312) 419 61 73",
            "address": "Milli Müdafa Caddesi No: 10 A-B Kızılay",
            "id": "ST063",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "kızılay",
            "name": "Demirtepe-2 MAĞAZASI",
            "phone": "",
            "address": "GMK Bulvarı No: 19 / A  Çankaya",
            "id": "ST064",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "eryaman",
            "name": "Eryaman-1 MAĞAZASI",
            "phone": "0312 280 79 75",
            "address": "Altay Mah. Söğüt Cad. No:2. Eryaman,Etimesgut / ANKARA",
            "id": "ST065",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "eryaman",
            "name": "Eryaman-3 MAĞAZASI",
            "phone": "0312 279 04 48",
            "address": "Eryaman Mah. 271. Cad. No:3. Eryaman,Etimesgut / ANKARA",
            "id": "ST066",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "eryaman",
            "name": "Bahçen MAĞAZASI",
            "phone": "0312 280 80 35",
            "address": "Şeker Mah. Şehit Mehmet Çavuş Cad. No:4. Etimesgut / ANKARA",
            "id": "ST067",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "eryaman",
            "name": "Göldekent MAĞAZASI",
            "phone": "0312 281 15 14",
            "address": "Şehit Osman Avcı Mah. Selçuklular Cad. No:44/G. Eryaman,Etimesgut / ANKARA.",
            "id": "ST068",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "eryaman",
            "name": "Şeker MAĞAZASI",
            "phone": "0312 503 03 37",
            "address": "Osman Avcı Mah. 1419. Cad. No:102. Eryaman,Etimesgut / ANKARA",
            "id": "ST069",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "eryaman",
            "name": "Eryaman-4 MAĞAZASI",
            "phone": "(312) 279 05 93",
            "address": "Eryaman Mahallesi, Dil Devrimi Caddesi No:15",
            "id": "ST070",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "eryaman",
            "name": "Şeker-2 MAĞAZASI",
            "phone": "(312) 511 15 14",
            "address": "Şehit Osman Avcı Mahallesi 1419.Cadde No: 2/A Etimesgut",
            "id": "ST071",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "batıkent",
            "name": "Andaş MAĞAZASI",
            "phone": "0312 252 55 58",
            "address": "Uğur Mumcu Mah. 3. Cad. Andaş Çarşısı No:16/2. Batıkent,Yenimahalle / ANKARA",
            "id": "ST072",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "batıkent",
            "name": "İlkyerleşim (Batıkent Metro) MAĞAZASI",
            "phone": "0312 385 52 48",
            "address": "İlkyerleşim Mah. Başkent Bulvarı No:204. Batıkent,Yenimahalle / ANKARA",
            "id": "ST073",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "batıkent",
            "name": "Batıpark MAĞAZASI",
            "phone": "0312 256 35 03",
            "address": "Kardelen Mah. 2040. Sok. No:2. Batıkent,Yenimahalle / ANKARA",
            "id": "ST074",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "batıkent",
            "name": "Meydan AVM MAĞAZASI",
            "phone": "0312 251 30 22",
            "address": "Kentkoop Mah. Batıkent Bulvarı No: 255/24-25. Batıkent,Yenimahalle / ANKARA",
            "id": "ST075",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "batıkent",
            "name": "Uğur Mumcu MAĞAZASI",
            "phone": "0312 250 75 78",
            "address": "Uğur Mumcu Mah. Rajiv Gandhi Cad. No:8/A. Batıkent,Yenimahalle / ANKARA",
            "id": "ST076",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "batıkent",
            "name": "Kardelen 2  MAĞAZASI",
            "phone": "0312 433 01 39",
            "address": "Kardelen Mah. 2110. Cad. No:1 Batıkent, Yenimahalle / ANKARA",
            "id": "ST077",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "batıkent",
            "name": "Akkent MAĞAZASI",
            "phone": "(312) 512 54 60",
            "address": "Turgut Özal Mahallesi 2167 Sokak C Blok No:6 3C/63 Batıkent",
            "id": "ST078",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "mamak",
            "name": "Akdere MAĞAZASI",
            "phone": "0312 389 04 00",
            "address": "Kutlu Mah. Dereboyu Cad. No:48/A. Mamak / ANKARA",
            "id": "ST079",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "mamak",
            "name": "Ege Mahallesi MAĞAZASI",
            "phone": "0312 390 52 55",
            "address": "Ege Mah. Natoyolu Cad. No: 292. Mamak / ANKARA",
            "id": "ST080",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "mamak",
            "name": "Natoyolu 1 MAĞAZASI",
            "phone": "0312 391 52 51",
            "address": "General Zeki Doğan Mah. Natoyolu Cad. No:96/A-B. Mamak / ANKARA",
            "id": "ST081",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "mamak",
            "name": "Natoyolu 3 MAĞAZASI",
            "phone": "0312 390 64 24",
            "address": "Ege Mah. Natoyolu Cad. No: 218/A-B-C. Mamak / ANKARA",
            "id": "ST082",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "mamak",
            "name": "Tuzluçayır MAĞAZASI",
            "phone": "0312 389 80 40",
            "address": "Tuzluçayır Mah. Süleyman Ayten Cad. No:35/A-D. Mamak / ANKARA",
            "id": "ST083",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "mamak",
            "name": "Ege 2 MAĞAZASI",
            "phone": "0312 514 36 70",
            "address": "Cengizhan Mah. Sultan Fatih Cad. No:18. Mamak / ANKARA",
            "id": "ST084",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "mamak",
            "name": "Natoyolu-4 MAĞAZASI",
            "phone": "(312) 367 39 07",
            "address": "Natoyolu Caddesi General Zeki Doğan Mahallesi No:2/A Mamak",
            "id": "ST085",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "mamak",
            "name": "MAMAK MAĞAZASI",
            "phone": "",
            "address": "FAHRİ KORUTÜRK MAHALLESİ ŞEHİTLER CADDESİ NO:48 MAMAK",
            "id": "ST086",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "yenimahalle",
            "name": "Lalegül MAĞAZASI",
            "phone": "0312 344 21 23",
            "address": "Gayret Mah. İstiklal Cad. Aden Plaza No:8/17-18-19-21. Yenimahalle / ANKARA",
            "id": "ST087",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "yenimahalle",
            "name": "Şentepe MAĞAZASI",
            "phone": "0312 330 50 80",
            "address": "Çiğdemtepe Mah. Değirmendere Cad. No:51. Şentepe, Yenimahalle / ANKARA",
            "id": "ST088",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "yenimahalle",
            "name": "YDA Park MAĞAZASI",
            "phone": "0312 504 44 05",
            "address": "Mehmet Akif Ersoy Mah. YDA Park Avenue Sitesi No:77/1. Yenimahalle / ANKARA",
            "id": "ST089",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "yenimahalle",
            "name": "Gayret Mahallesi MAĞAZASI",
            "phone": "(312) 344 17 66",
            "address": "Gayret Mahallesi İvedik Caddesi No:29/19 Yenimahalle",
            "id": "ST090",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "yenimahalle",
            "name": "YeniBatı  MAĞAZASI",
            "phone": "0312 511 90 37",
            "address": "Yeni Batı mahallesi 5419. Cadde no:9 astim metrolife sitesi önü, 06370 Yenimahalle/Ankara",
            "id": "ST091",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "yenimahalle",
            "name": "GALA MAĞAZASI MAĞAZASI",
            "phone": "",
            "address": "ERGAZİ MAHALLESİ CENGİZ AYTMATOV CADDESİ NO:19 NO:19/N:1 YENİMAHALLE",
            "id": "ST092",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "keçiören",
            "name": "Sanatoryum MAĞAZASI",
            "phone": "0312 314 97 98",
            "address": "Tepebaşı Mah. Bilgi Sok. No:1. Keçiören / ANKARA",
            "id": "ST093",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "keçiören",
            "name": "İncirli MAĞAZASI",
            "phone": "0312 314 12 75",
            "address": "19 Mayıs Mah. 19 Mayıs Cad. No:16/A. Keçiören / ANKARA",
            "id": "ST094",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "gölbaşı",
            "name": "Gölbaşı 1 MAĞAZASI",
            "phone": "0312 484 90 11",
            "address": "Karşıyaka Mah, Haymana Yolu Bulvarı No:16. Gölbaşı / ANKARA",
            "id": "ST095",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "gölbaşı",
            "name": "Gölbaşı 2  MAĞAZASI",
            "phone": "0312 485 16 13",
            "address": "Şafak Mah. Şehit Selami Atabey Cad. No:43. Gölbaşı / ANKARA",
            "id": "ST096",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "gölbaşı",
            "name": "Gölbaşı 3 MAĞAZASI",
            "phone": "0312 485 30 19",
            "address": "Gaziosmanpaşa Mah. Ankara Cad. No:10/A. Gölbaşı / ANKARA",
            "id": "ST097",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "gölbaşı",
            "name": "Gölbaşı-4 MAĞAZASI",
            "phone": "(312) 485 09 26",
            "address": "Bahçelievler Mahallesi Cemal Gürsel Caddesi No: 2/A Gölbaşı",
            "id": "ST098",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "gölbaşı",
            "name": "İNCEK TEKYAPI MAĞAZASI",
            "phone": "",
            "address": "KIZILCAŞAR MAHALLESİ 1209. CADDE NO:3 C BLOK 32-33-34 GÖLBAŞI",
            "id": "ST099",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "altındağ",
            "name": "Türk İş MAĞAZASI",
            "phone": "0312 316 20 52",
            "address": "Seyfi Demirsoy Mah. Erda Sok. No:19/62. Aydınlıkevler, Altındağ / ANKARA",
            "id": "ST100",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "sincan",
            "name": "Sincan Organize MAĞAZASI",
            "phone": "0312 267 25 23",
            "address": "Gökçek Mah. 362. Sok. No:11/1-2-3. OSB, Sincan / ANKARA",
            "id": "ST101",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "sincan",
            "name": "Şaşmaz MAĞAZASI",
            "phone": "0312 278 00 32",
            "address": "Bahçekapı Mah. 2473. Cad. No:21. Şaşmaz, Sincan / ANKARA",
            "id": "ST102",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "sincan",
            "name": "Dumlupınar MAĞAZASI",
            "phone": "0312 577 69 38",
            "address": "FATİH SULTAN MEHMET MH. DUMLUPINAR BUL. NO : 375 C-1 ETİMESGUT",
            "id": "ST103",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "ankara",
            "province": "sincan",
            "name": "AYAŞ YOLU MAĞAZASI",
            "phone": "",
            "address": "Şeker Mah. Ayaş Yolu Ankara Bulvarı No:102/B Etimesgut/Ankara",
            "id": "ST104",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "batıkent",
            "name": "Batıkent MAĞAZASI",
            "phone": "0222 315 04 06",
            "address": "Batıkent Mah. Harbiye Sok. No:62/A. Karagözler, Tepebaşı / ESKİŞEHİR",
            "id": "ST105",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "batıkent",
            "name": "Tepebaşı MAĞAZASI",
            "phone": "0222 330 22 22",
            "address": "Uluönder Mah. Halis Sok. No:71/1. Tepebaşı / ESKİŞEHİR",
            "id": "ST106",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "batıkent",
            "name": "Batıkent 2 MAĞAZASI",
            "phone": "0222 315 05 90",
            "address": "Batıkent Mah. Kapıkule Sok. No:1/A. Tepebaşı / ESKİŞEHİR",
            "id": "ST107",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "batıkent",
            "name": "Gala MAĞAZASI",
            "phone": "",
            "address": "Ergazi Mahallesi, Cengiz Aytimov Caddesi No:19/ 19/1 Batıkent, Yenimahalle",
            "id": "ST108",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "batıkent",
            "name": "Uğur Mumcu MAĞAZASI",
            "phone": "(312) 250 75 78",
            "address": "Uğur Mumcu Mahallesi Rajiv Gandhi Caddesi No:8/A Batıkent",
            "id": "ST109",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "batıkent",
            "name": "Çakırlar-2 MAĞAZASI",
            "phone": "(312) 566 09 75",
            "address": "Turgut Özal Mahallesi, Şehit Kaymakam Muhammed Fatih Safitürk Bulvarı Büyük Elit Sitesi No: 116 Yenimahalle, Batıkent",
            "id": "ST110",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "batıkent",
            "name": "Çakırlar-3 MAĞAZASI",
            "phone": "",
            "address": "Yeni Batı Mahallesi, Veysel Karani Bulvarı No:1/1 İç Kapı No:3 Yenimahalle, Ankara",
            "id": "ST111",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "çarşı",
            "name": "Porsuk MAĞAZASI",
            "phone": "0222 230 05 70",
            "address": "İstiklal Mah. Porsuk Bulvarı No:3. Köprübaşı, Odunpazarı / ESKİŞEHİR",
            "id": "ST112",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "çarşı",
            "name": "İstiklal MAĞAZASI",
            "phone": "0222 221 62 42",
            "address": "İstiklal Mah. Mustafa Kemal Atatürk Cad. No:74. Odunpazarı / ESKİŞEHİR",
            "id": "ST113",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "çarşı",
            "name": "Tunalı MAĞAZASI",
            "phone": "0222 400 01 70",
            "address": "Tunalı Mah. Prof. Dr. Orhan Oğuz Cad. 2A Blok 19-20. Tepebaşı / ESKİŞEHİR",
            "id": "ST114",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "çarşı",
            "name": "Cengiz Topel MAĞAZASI",
            "phone": "0222 232 24 26",
            "address": "Hoşnudiye Mah. Cengiz Topel Cad. No:52/A. Tepebaşı / ESKİŞEHİR.",
            "id": "ST115",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "çarşı",
            "name": "Bayat Pazarı MAĞAZASI",
            "phone": "0222 231 50 57",
            "address": "Hacı Ali Bey Mah. Çelikel Sok. No:3. Tepebaşı / ESKİŞEHİR",
            "id": "ST116",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "çarşı",
            "name": "Kurtuluş MAĞAZASI",
            "phone": "0222 230 79 99",
            "address": "Kurtuluş Mah. Vatan Cad. No:27. Odunpazarı / ESKİŞEHİR",
            "id": "ST117",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "çarşı",
            "name": "Şeker MAĞAZASI",
            "phone": "0222 210 00 71",
            "address": "Şeker Mah. Sivrihisar Cad. No:119. Tepebaşı / ESKİŞEHİR",
            "id": "ST118",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "çarşı",
            "name": "Hatboyu MAĞAZASI",
            "phone": "0222 290 15 88",
            "address": "Güllük Mah. Hatboyu-1 Cad. No:15/A. Tepebaşı / ESKİŞEHİR",
            "id": "ST119",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "çarşı",
            "name": "Çağlayan MAĞAZASI",
            "phone": "0222 502 00 81",
            "address": "Ömer Ağa Mah. Çağlayan Sk. No:20. Tepebaşı / ESKİŞEHİR",
            "id": "ST120",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "büyükdere",
            "name": "Ihlamurkent MAĞAZASI",
            "phone": "0222 244 01 03",
            "address": "Çankaya Mah. Kartopu Cad. No:75/5. Odunpazarı / ESKİŞEHİR",
            "id": "ST121",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "büyükdere",
            "name": "Vişnelik MAĞAZASI",
            "phone": "0222 226 58 68",
            "address": "Akarbaşı Mah. Ali Fuat Güven Cad. No:58/A-B. Odunpazarı / ESKİŞEHİR",
            "id": "ST122",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "büyükdere",
            "name": "Büyükdere MAĞAZASI",
            "phone": "0222 229 25 61",
            "address": "Büyükdere Mah. Halk Cad. No:144. Odunpazarı / ESKİŞEHİR",
            "id": "ST123",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "büyükdere",
            "name": "Yıldıztepe MAĞAZASI",
            "phone": "0222 229 00 60",
            "address": "Yıldıztepe Mah. Şehit Yüzb.Tuncer Güngör Cad. No:94/A Odunpazarı / ESKİŞEHİR.",
            "id": "ST124",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "büyükdere",
            "name": "Yıldıztepe 2 MAĞAZASI",
            "phone": "0222 219 18 81",
            "address": "Yıldıztepe Mah. Ali Çetinkaya Cad. No:11. Odunpazarı / ESKİŞEHİR",
            "id": "ST125",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "büyükdere",
            "name": "Vadişehir  MAĞAZASI",
            "phone": "0222 219 18 84",
            "address": "Vadişehir Mah. Altınözü Sok. Odunpazarı / ESKİŞEHİR",
            "id": "ST126",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "büyükdere",
            "name": "Tıp Fakültesi MAĞAZASI",
            "phone": "",
            "address": "Büyükdere Mahallesi, Fakülte Sokak A2 Apt. No: 4-G Odunpazarı",
            "id": "ST127",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "sanayi",
            "name": "Emek 1 MAĞAZASI",
            "phone": "0222 260 00 65",
            "address": "Emek Mah. Ertaş Cad. No:160. Odunpazarı / ESKİŞEHİR",
            "id": "ST128",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "sanayi",
            "name": "Emek 2 MAĞAZASI",
            "phone": "0222 250 00 15",
            "address": "Emek Mah. Ertaş Cad. No:4. Odunpazarı / ESKİŞEHİR",
            "id": "ST129",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "sanayi",
            "name": "Gündoğdu MAĞAZASI",
            "phone": "0222 237 37 56",
            "address": "Gündoğdu Mah. Borsa Cad. No:27. Odunpazarı / ESKİŞEHİR",
            "id": "ST130",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        },
        {
            "city": "eskişehir",
            "province": "sanayi",
            "name": "71 Evler MAĞAZASI",
            "phone": "0222 227 00 97",
            "address": "Güneli Sokak No:2 Odunpazarı (Shell Benzinlik içi)",
            "id": "ST131",
            "active": true,
            "createdOn": "01.04.2025 17:31:23",
            "users":[
                0
            ]
        }
    ]
